import { useQuery } from '@tanstack/react-query';
import { requestStripeUrl } from '../stripeBilling/stripeBilling';
import { CreateStripeSessionRequest } from '../stripeBilling/types/createStripeSessionRequest';

export function useGetStripeUrl(offerKey: CreateStripeSessionRequest) {
    return useQuery({
        queryKey: [`stripeBilling-${offerKey.offerKey}`],
        queryFn: async ({ signal }) => (await requestStripeUrl(offerKey, signal)).data,
    });
}
